var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RiseupHeader',[(_vm.showBack)?_c('div',_vm._g({staticClass:"back",class:{ disabled: _vm.disabled }},_vm.disabled ? {} : { click: _vm.onBack }),[_c('img',{staticClass:"back-triangle",attrs:{"src":require('@/assets/nav/left-arrow.svg')}}),_vm._v(" "),_c('span',[_vm._v("חזרה")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f6f8eec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base-components/app-header/BackNavigationHeader.vue
// module id = null
// module chunks = 